<template lang="pug">
#mp.tab-pane.fade.show.active
  .mb-2
    label.col-form-label {{ $t("ui.account_id") }} :
    input.form-control.input-disabled(type='text' :placeholder="$store.getters.accountID" disabled)
  .mb-2
    label.col-form-label {{ $t("ui.full_name") }} :
    input.form-control.input-disabled(type='text' :placeholder="$store.state.user.account.full_name" disabled)
  .mb-2
    label.col-form-label {{ $t("ui.contact_number") }} :
    input.form-control.input-disabled(type='text' :placeholder="$store.getters.contactNumber" disabled)
  .mb-2
    label.col-form-label {{ $t("ui.register_date") }}
    input.form-control(type="text" :placeholder="$moment($store.state.user.account.verified_date).format('YYYY-MM-DD')" disabled)
  //- .mb-2
  //-   label.col-form-label {{ $t("ui.email") }} :
  //-   input.form-control(type='text' v-model.trim="$v.fullEmail.$model")
  //- validation(:value="$v.fullEmail" :name="$t('ui.email')" target="REGISTEREMAIL")
  //- template(v-if="!allowEdit")
  //-   .mt-4.text-center
  //-     button.btn-submit(v-if="!loading" type='button' @click="toggleEdit") {{ $t('ui.edit') }}
  //-     button.btn-submit.disabled-grey(v-else type='button')
  //-       i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
  //- template(v-else)
    .mt-4.text-center.d-flex.justify-content-evenly
      button.btn-submit(v-if="!loading" type='button' @click="profileUpdate") {{ $t('ui.update') }}
      button.btn-submit.disabled-grey(v-else type='button')
        i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
      button.btn-submit(type="button" @click="toggleEdit") {{$t('ui.cancel')}}
</template>
<script>
import { email } from 'vuelidate/lib/validators'
import validation from "@/library/_validation.vue"
export default {
  components: {
    validation
  },
  data(){
    return{
      url: "",
      allowEdit: false,
      fullName: this.$store.getters.username,
      fullEmail: this.$store.getters.email,
      loading: false,
      isDisabled: true
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    // getReferralcode(){
    //   return this.$store.state.user.account.referral_code || ""
    // },
  },
  validations:{
    fullEmail: {
      email,
    },
  },
  mounted(){
    this.url = window.location.protocol + "//" +window.location.hostname +'/register?ref='+ this.getReferralcode
  },
  methods:{
    // toggleEdit(){
    //   this.allowEdit = !this.allowEdit
    //   this.isDisabled = !this.isDisabled
    //   if(this.allowEdit === true){
    //     this.$nextTick(() => this.$refs.fullnames.focus())
    //   }
    // },
    // profileUpdate(){
    //   if (this.sessionToken) {
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let full_name = this.fullName
    //     let contact_email = this.fullEmail
    //     this.$store
    //       .dispatch("user/profileUpdate", { account_id, auth_token, full_name, contact_email })
    //       .then(response => {
    //         if (response.success == true) {
    //           this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
    //         } else {
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }    
    //         }
    //         this.toggleEdit()
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //         this.toggleEdit()
    //       });
    //   }
    // }
  }
}
</script>